import { getColorMapWithReverseSupport } from 'components/atoms/ColorMapSelect/utils';
import type { LayerVisualizationSettings } from 'components/Procedure/Infobar/slidesVisualizationAndConfiguration';
import type { FeatureMetadata } from 'components/Procedure/useSlideChannelsAndResults/featureMetadata';

export const defaultScoreColorMap = 'viridis';
export const scoreOverlaySettingsId = 'scores';
export const getScoreMarkerSettingsId = (markerId: string) => `scores:${markerId}`;

export const areZeroScoresHidden = (settings?: Partial<LayerVisualizationSettings>): boolean =>
  settings?.additionalProperties?.hideZeroScores !== false;

const palettes = new Map<string, string[]>();

export const getScoreColor = (
  heatmap: Pick<FeatureMetadata, 'options'>,
  score: string | number,
  colorMap = defaultScoreColorMap
): string => {
  let palette = palettes.get(colorMap);
  if (!palette) {
    palette = getColorMapWithReverseSupport({ colormap: colorMap, nshades: 256, format: 'hex', alpha: 1 }) as string[];
    palettes.set(colorMap, palette);
  }
  const maxScore = Math.max(1, ...(heatmap.options || []).map((option) => Number(option.key)));
  const index = Math.round(Math.max(0, Math.min(1, Number(score) / maxScore)) * (palette.length - 1));
  return palette[index];
};
